import { Button, styled, TableCell, Typography } from '@mui/material'

export const IdText = styled(Typography)(({ theme }) => ({
  fontSize: 10,
  color: theme.palette.grey[500],
})) as typeof Typography

export const CSVButton = styled(Button)(() => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
})) as typeof Button

export const VerificationCell = styled(TableCell)(() => ({
  width: 150,
}))
